<template>
  <el-container>
    
    <el-main>
      <el-form ref="searchDate" :model="searchData" label-width="80px" label-position="top">
        <el-row >
          <el-col :span="7" >
            <el-form-item label="日期" prop="date" >
              <el-date-picker
                  size="small"
                  style="width: 80%"
                  v-model="searchData.date"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="7" >
            <el-form-item label="时间" prop="createTime" >
              <el-time-select
                  placeholder="起始时间"
                  v-model="searchData.htimeStart"
                  style="width: 40%"
                  size="small"
                  :picker-options="{
                  start: '08:00',
                  step: '00:30',
                  end: '18:30'
                }">
              </el-time-select> 至
              <el-time-select
                  placeholder="结束时间"
                  v-model="searchData.htimeEnd"
                  style="width: 40%"
                  size="small"
                  :picker-options="{
                  start: '08:30',
                  step: '00:30',
                  end: '18:30',
                  minTime: startTime
                }">
              </el-time-select>
            </el-form-item>
          </el-col>
          <el-col :span="7" class="cls-col">
            <el-form-item label="学生账号" prop="userName">
              <el-input v-model="searchData.studentName" placeholder="用户名" size="small" style="width: 80%" ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="7" >
            <el-form-item label="预约状态" prop="status">
              <el-select v-model="searchData.status" size="small" style="width: 80%" clearable>
                <el-option label="未开始" :value="4"></el-option>
                <el-option label="已完成" :value="1"></el-option>
                <el-option label="已取消" :value="2"></el-option>
                <el-option label="已过期" :value="3"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item >
          <el-button type="primary" plain size="small" icon="el-icon-search" @click="search()">查询</el-button>
          <el-button type="success" icon="el-icon-download" size="small" class="but-cls" @click="download()">导出</el-button>
        </el-form-item>
      
      </el-form>

      <span style="font-size: 16px">共<span style="color: #0dafe0">{{total}}</span>条记录</span>
      <el-table
          :data="reserveList"
          border
          highlight-current-row
          style="width: 100%"
      >
        <el-table-column
            type="index"
            label="序号"
            width="50">
        </el-table-column>
        <el-table-column
            prop="studentName"
            label="学生账号"
        >
          <template slot-scope="scope">
             <el-button  type="text" style="font-size: 15px" @click="showUser(scope.row)" >{{scope.row.studentName}}</el-button>
          </template>
        </el-table-column>
        <el-table-column
            prop="studentNameView"
            label="学生姓名"
            width="200"
        >
        </el-table-column>
        <el-table-column
            prop="createTime"
            label="预约日期"
            width="200"
            :formatter="timeFormat"
        >
        </el-table-column>
        <el-table-column
            prop="htime"
            label="预约时间"
            width="200"
        >
        </el-table-column>
        <el-table-column
            prop="managerName"
            label="试讲老师"
            width="200"
        >
        </el-table-column>
        <el-table-column
            prop="status"
            label="预约状态"
            width="150"
            :formatter="statusFormat"
        >
        </el-table-column>
        <el-table-column
            fixed="right"
            label="操作"
            width="200"
        >
          <template slot-scope="scope">
            <el-button @click="detail(scope.row)" type="text" size="small">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        layout="prev, pager, next"
        :total="total"
        :page-size="pageSize"
        :current-page.sync="currentPage"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        style="margin-top: 10px; float: right; margin-right: 10px">
      </el-pagination>
      <el-dialog
          title="预约详情"
          :visible.sync="reserveDetailDialog"
          width="450px"
          :before-close="chanelReserveDetailDialog"
          :close-on-click-modal=false
      >
        <el-form class="demo-ruleForm" align="left" label-width="100px" v-model="currentEvent">
          <el-form-item label="预约时间：" prop="userName">{{formatReserveDate(currentEvent.createTime)}} {{currentEvent.htime}}</el-form-item>
          <el-form-item label="学生姓名：" prop="studentName">{{currentEvent.studentNameView}}</el-form-item>
          <el-form-item label="所在时区：" prop="phone">{{currentEvent.studentTimeZone}}</el-form-item>
          <el-form-item label="学生账号：" prop="studentName">{{currentEvent.studentName}}</el-form-item>
          <el-form-item label="学生留言：" prop="studentMessage"></el-form-item>
          <div style="margin-left: 13px;">{{currentEvent.studentMessage}}</div>
          <el-button
              round
              type="success"
              size="small"
              style="height: 30px; width: 100px; margin-left: 10px; line-height: 0px; margin-top: 15px"
              @click="goto(currentEvent.meetingUrl)"
          >进入教室</el-button>
        </el-form><br>
        <el-form class="demo-ruleForm" ref="reserveForm" align="left" label-width="100px" :model="currentEvent">
          <el-form-item label="预约状态：" prop="status" >
            <!--<el-select v-model="currentEvent.status" size="small">
              <el-option label="未开始" :value="4"></el-option>
              <el-option label="已取消" :value="2"></el-option>
              <el-option label="完成" :value="1"></el-option>
              <el-option label="过期" :value="3"></el-option>
            </el-select>-->
            <el-button type="text" disabled style="color: #606266" v-if="currentEvent.status == 4">未开始</el-button>
  
            <el-button type="text" disabled style="color: #606266" v-if="currentEvent.status == 3">已过期</el-button>
            <el-button type="text" v-if="currentEvent.status == 3" @click="finishReserve(2)">(取消)</el-button>
            <el-button type="text" disabled style="color: #606266" v-if="currentEvent.status == 2">已取消</el-button>
            <el-button type="text" disabled style="color: #606266" v-if="currentEvent.status == 1">已完成</el-button>
            <el-button type="text" @click="finishReserve(1)" v-if="currentEvent.status != 1 && currentEvent.status != 2">(完成)</el-button>
          </el-form-item>
          <el-form-item label="试讲教师：" prop="userName">{{currentEvent.managerName}}</el-form-item>
          <el-form-item label="教师留言：" prop="managerMessage">
          </el-form-item>
          <el-input
              type="textarea"
              :rows="3"
              style="margin-left: 12px"
              v-model="currentEvent.managerMessage"
              :disabled="oldStatus == 2"
              placeholder="教师留言"
              size="small"
          ></el-input>
        </el-form>
        <div slot="footer" class="dialog-footer" style="text-align: left">
          <el-button
              round
              type="success"
              size="small"
              style="height: 30px; width: 100px; margin-left: 5px"
              @click="submitMessage"
          >提交</el-button>
          <el-button
              round
              type="info"
              size="small"
              style="height: 30px; width: 100px;"
              @click="chanelReserveDetailDialog"
          >取消</el-button>
        </div>
      </el-dialog>

      <el-dialog
          title="用户详情"
          :visible.sync="detailDialog.show"
          width="30%"
          :close-on-click-modal=false
          :before-close="handleDetailClose"
          id="detailDialog"
            >
          <el-form class="demo-ruleForm" align="left" label-width="100px">
              <el-form-item label="用户名：" prop="userName">{{detailDialog.data.userName}}</el-form-item>
              <el-form-item label="听说渠道：" prop="referralSource">{{detailDialog.data.referralSource}}</el-form-item>
              <el-form-item label="手机号：" prop="phone">{{detailDialog.data.phone}}</el-form-item>
              <!-- <el-form-item label="头像：" prop="headerUrl">
                  <img style="height:90px" :src="detailDialog.data.headerUrl" />
              </el-form-item> -->
              <!-- <el-form-item label="密码：" prop="password">--</el-form-item> -->
              <!-- <el-form-item label="姓名：" prop="realName">{{detailDialog.data.passportFirstName}}{{ detailDialog.data.passportLastName }}</el-form-item> -->
              <!-- <el-form-item label="性别：" prop="sex">{{detailDialog.data.sex | sexFilter}}</el-form-item> -->
              <el-form-item label="邮箱：" prop="email">{{detailDialog.data.email}}</el-form-item>
              <!-- <el-form-item label="学历：" prop="education">{{detailDialog.data.education}}</el-form-item>
              <el-form-item label="所在省份：" prop="province">
                  {{detailDialog.data.provinceName}}{{detailDialog.data.cityName}}{{detailDialog.data.districtName}}
              </el-form-item>
              <el-form-item label="QQ：" prop="qq">{{detailDialog.data.qq}}</el-form-item> -->
              <!-- <el-form-item label="收货地址：" prop="consigneeAddress">{{detailDialog.data.consigneeAddressAll}}</el-form-item> -->
              <el-form-item label="护照姓：" prop="passportFirstName">{{detailDialog.data.passportFirstName}}</el-form-item>
              <el-form-item label="护照名：" prop="passportLastName">{{detailDialog.data.passportLastName}}</el-form-item>
              <el-form-item label="国籍：" prop="nationalityZh">{{detailDialog.data.nationalityZh}}</el-form-item>
              <!-- <el-form-item prop="birthday" label="生日：">{{detailDialog.data.birthday | dateFormatFilter}}</el-form-item> -->
              <el-form-item prop="originSource" label="生源：">{{detailDialog.data.originSource}}</el-form-item>
              <!-- <el-form-item prop="createTime" label="注册日期："   :formatter="createTimeFormat">{{detailDialog.data.createTime | dateFormatFilter1}}</el-form-item> -->
              <el-form-item label="现居地：" prop="address">{{detailDialog.data.address}}</el-form-item>
  
          </el-form>
      </el-dialog>
    </el-main>
  </el-container>
</template>

<script>
  import https from '@/https.js'
  import {dateFormat} from '@/api/utils.js';
  
  export default {
    name: '',
    data() {
      return {
        oldStatus: '',
        reserveList: [],
        total: 0,
        reserveDetailDialog: false,
        appointmentStudent: '',
        currentEvent: '',
        pageSize: 10,
        currentPage: 1,
        startTime: '',
        endTime: '',
        searchData: {
          date: [],
          htimeStart: '',
          htimeEnd: '',
          createTimeStart: '',
          createTimeEnd: '',
          userName: '',
          studentName: "",
          status: '',
          page: 0,
          size: 10
        },
        detailDialog: {
          data: {},
          show: false
        }
      };
    },
    methods: {
      handleSizeChange() {
      },
      handleCurrentChange(val) {
          this.search(val);
      },
      handleSelectionChange(val) {
          this.multipleSelection = [];
          for(let index in val) {
              this.multipleSelection[index] =  val[index].logId;
          }
      },
      search(val) {
        let params = this.searchData;
        this.searchData.size = this.pageSize;
        if(val) {
            this.searchData.page = val;
        } else {
            this.searchData.page = 1;
            this.currentPage = 1;
        }
        if(this.searchData.date && this.searchData.date.length == 2) {
          params.createTimeStart = this.searchData.date[0];
          params.createTimeEnd = this.searchData.date[1];
        } else {
          params.createTimeStart = '';
          params.createTimeEnd = '';
        }
        console.log(params);
        this.https.fetchPost('/appointmentManagerInfo/selectListByAppointmentConditionVo', params, 'json').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          console.log("预约信息列表：",data);
          if (code == 200) {
            if(data.data.data) {
              this.reserveList = data.data.data;
              this.total = data.data.total;
            } else {
              this.reserveList = [];
              this.total = 0;
            }
          } else {
            this.$message({type: 'info', message: '加载失败:' + msg
            });
          }
        }).catch((err) => {
          console.log(err);
          this.$message.error('网络错误');
        });
      },
      download() {
        let params = this.searchData;
        if(this.searchData.date && this.searchData.date.length == 2) {
          params.createTimeStart = this.searchData.date[0];
          params.createTimeEnd = this.searchData.date[1];
        } else {
          params.createTimeStart = '';
          params.createTimeEnd = '';
        }
        https
            .fetchPost('/appointmentManagerInfo/downloadAppointmentCondition', params, 'json', '', 'blob')
            .then((res) => {
                let fileName = '学生预约信息列表.xls';
                let type = res.headers['content-type'];
                let blob = new Blob([res.data], {type: type});

                if (window.navigator.msSaveBlob) {
                    navigator.msSaveBlob(blob, fileName);
                } else {
                    const elink = document.createElement('a');
                    elink.download = fileName;
                    elink.style.display = 'none';
                    elink.href = window.URL.createObjectURL(new Blob([res.data]));
                    document.body.appendChild(elink);
                    elink.click();
                    URL.revokeObjectURL(elink.href); // 释放URL 对象
                    document.body.removeChild(elink);
                }
            })
            .catch(() => {
                this.$message.error('下载附件失败，请联系管理员');
            });
      },
      detail(row) {
        this.reserveDetailDialog = true;
        this.currentEvent = row;
        this.oldStatus = this.currentEvent.status;
      },
      goto(url) {
        window.open(url);
      },
      timeFormat(row, index,val){
        return dateFormat(val).substr(0,10);
      },
      statusFormat(row, index,val) {
        // 未开始：4，已完成：1，已取消：2, 已过期：3
        if(val == 1) {
          return "已完成"
        }
        if(val == 2) {
          return "已取消"
        }
        if(val == 3) {
          return "已过期"
        }
        if(val == 4) {
          return "未开始"
        }
      },
      formatReserveDate(val) {
        return dateFormat(new Date(val)).substr(0,10);
      },
      finishReserve(val) {
        this.currentEvent.status = val;
        
      },
      chanelReserveDetailDialog() {
        this.currentEvent.status = this.oldStatus;
        this.reserveDetailDialog = false;
        this.$refs['reserveForm'].resetFields();
      },
      handleDetailClose() {
        this.detailDialog.show = false;
      },
      createTimeFormat(row, column, cellValue, index) {
        if(cellValue) {
          return dateFormat(cellValue).substr(0,16);
        }
      }, 
      dateFormatFilter(val) {
        return dateFormat(val).substr(0,10);
      },
      dateFormatFilter1(val) {
        return dateFormat(val).substr(0,16);
      },
      sexFilter(val) {
        if(val == 0) {
          return '保密';
        }
        if(val == 1) {
          return '女';
        }
        if(val == 2) {
          return '男';
        }
      },                   
      showUser(item) {
        console.log('学生信息',item);
        let params = {
          userName: item.studentName
        };
        this.detailDialog.data = {};
        https.fetchPost('/managerStudent/findUser', params, 'json')
            .then((res) => {
              let code = res.data.code;
              let msg = res.data.msg;
              console.log("学生信息查询结果",res);
              if (code == 200) {
                if(res.data.data[0]) {
                  this.detailDialog.data = res.data.data[0];
                }
              } else {
                this.$message({
                  type: 'info',
                  message: msg
                });
              }
            })
            .catch(() => {
              this.$message.error('网络错误，请联系管理员');
            });

        this.detailDialog.show = true;
      },
    
      submitMessage() {
        if(this.currentEvent.managerMessage && this.currentEvent.managerMessage.length >50) {
          this.$message({
            type: 'info',
            message: '留言不能超过50个字！'
          });
          return;
        }
        let params = {
          appointmentManagerId: this.currentEvent.appointmentManagerId,
          appointmentStudentInfoVoList: [{
            appointmentStudentId: this.currentEvent.appointmentStudentId,
            status: this.currentEvent.status,
          }],
          managerMessage: this.currentEvent.managerMessage
        }
        this.https.fetchPost('/appointmentManagerInfo/updateAppointmentManagerInfoVoByAppointmentStudentId', params, 'json').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == 200) {
            this.$message({
              type: 'success',
              message: '提交成功！'
            });
            this.reserveDetailDialog = false;
          } else {
            this.$message({
              type: 'info',
              message: '操作失败！'
            });
          }
        }).catch((err) => {
          console.log(err);
          this.$message.error('网络错误');
        });
      },
    },
    created: function() {
      this.search();
    }
  };
</script>

<style >
  .el-form-item__label {
    font-weight: bold;
    font-size: 15px;
    height: 40px;
  }
  .el-dialog__header {
    padding: 0;
    padding-left: 33px;
    font-weight: bold;
  }
</style>
